import React from "react";
import Modal from "react-modal";
import { Title } from "./styled";
import { Container, Close, ContainerLegend, BoxEmails, BoxTemplate, BoxTemplateContent } from "./styled";
import { CalendarDaysIcon, CodeBracketIcon, CreditCardIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { useState } from "react";
import { IoIosClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/20/solid'
import { translations } from '../../../../utils/language'


const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        width: "750px",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: "white",
        padding: "0px",
        margin: "0px",
        borderRadius: "8px",
        boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)",
        border: "1px solid #e5e7eb",
        maxHeight: "90vh",
        overflow: "auto",
    },
    overlay: {
        backgroundColor: "rgba(107, 114, 128, 0.75)",
        zIndex: "99999999",
    },
};

const ModalEmails = (props) => {
    // Função para formatar a data (subtraindo 3 horas do UTC para horário local)
    const formatDate = (dateString) => {
        if (!dateString) return "";

        const date = new Date(dateString);
        // Subtraindo 3 horas (UTC-3)
        date.setHours(date.getHours() - 0);

        // Formatando a data no padrão brasileiro
        return date.toLocaleString(language.data === 'es' ? 'es-ES' : 'pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    const [template, setTemplate] = useState({
        id: 0,
        data: "",
        text: "",
        status: "success",
        to: "",
        subject: "",
        html: ""
    })
    const dispatch = useDispatch()
    const historyEmails = useSelector((state) => state.reducerHistoryEmails);
    const language = useSelector((state) => state.reducerLanguage);


    useEffect(() => {
        console.log("props_item", props.item)
        // setProducts(JSON.parse(props.item.order_items_codes))
        if (props.visible) {
            console.log("testando props setVisibleModal", props.visible)
            dispatch({
                type: "SAGA_GET_HISTORY_EMAILS",
                payload: { order_id: props.item.order_id },
            });
        }
    }, [props])

    useEffect(() => {
        if (props.visible && historyEmails?.data?.data?.data && historyEmails.data.data.data.length > 0) {
            console.log("historyEmails", historyEmails.data.data.data[0]);
            // Definir o primeiro email como template quando os dados estiverem disponíveis
            setTemplate(historyEmails.data.data.data[0]);
        }
    }, [historyEmails, props.visible])



    return (
        <Modal
            isOpen={props.visible}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { props.setVisibleModal(false) }}
        >
            <Container>
                {!historyEmails.loading && <Title marginBottom="16px">{translations["sales-emails-enviados"][language.data]}</Title>}
                <Close onClick={() => props.setVisibleModal(false)}><IoIosClose size={22} color={"currentColor"} /></Close>
                {/* <ContainerLegend></ContainerLegend> */}

                <div className="mb-5 flex gap-3 sm:gap-4">
                    <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-amber-50">
                        <ExclamationTriangleIcon aria-hidden="true" className="size-5 text-amber-500" />
                    </div>
                    <div className="min-w-0 pt-0.5">
                        <h3 className="text-sm font-semibold leading-none text-gray-900">
                            {translations["sales-emails-atencao"][language.data]}
                        </h3>
                        <p className="mt-2 text-sm leading-relaxed text-gray-600">
                            {translations["sales-emails-aviso"][language.data]}
                        </p>
                    </div>
                </div>

                <div className="flex w-full gap-4">
                    <div className="min-w-0 flex-1">
                        <BoxEmails style={{ margin: 0 }}>
                            {historyEmails.loading ? (
                                <div className="px-4 py-8 text-center">
                                    <div className="spinner mx-auto size-9 rounded-full border-4 border-gray-200 border-l-gray-900" style={{
                                        animation: 'spin 1s linear infinite'
                                    }}></div>
                                    <style>{`
                                        @keyframes spin {
                                            0% { transform: rotate(0deg); }
                                            100% { transform: rotate(360deg); }
                                        }
                                    `}</style>
                                    <p className="mt-3 text-sm text-gray-500">{translations["sales-emails-carregando"][language.data]}</p>
                                </div>
                            ) : historyEmails?.data?.data?.data && historyEmails.data.data.data.length > 0 ? (
                                historyEmails.data.data.data.map((item) => (
                                    <div
                                        key={item.id}
                                        onClick={() => setTemplate(item)}
                                        className={[
                                            "flex cursor-pointer items-center justify-between rounded-md border px-3 py-2.5 transition-colors",
                                            template.id === item.id
                                                ? "border-gray-300 bg-gray-100"
                                                : "border-transparent bg-white hover:bg-gray-50"
                                        ].join(" ")}
                                    >
                                        <div className="min-w-0">
                                            <p className="m-0 mb-1 text-sm font-medium text-gray-900">
                                                {item.template_name === "codes"
                                                    ? translations["sales-emails-codigos-enviados"][language.data]
                                                    : translations["sales-emails-pedido-enviado"][language.data]}
                                            </p>
                                            <p className="m-0 text-xs text-gray-500">
                                                {formatDate(item.created_at)}
                                            </p>
                                        </div>
                                        <div className="size-2.5 shrink-0 rounded-full bg-emerald-500" />
                                    </div>
                                ))
                            ) : (
                                <div className="px-4 py-8 text-center">
                                    <p className="m-0 text-sm text-gray-500">{translations["sales-emails-nenhum"][language.data]}</p>
                                </div>
                            )}
                        </BoxEmails>
                    </div>

                    <div
                        className="flex"
                        style={{
                            width: '65%',
                            display: historyEmails?.data?.data?.data && historyEmails.data.data.data.length > 0 ? 'flex' : 'none'
                        }}
                    >
                        <BoxTemplate>
                            <div className="mb-3 flex flex-col gap-1">
                                <p className="m-0 text-sm text-gray-600">
                                    <span className="font-semibold text-gray-900">{translations["sales-emails-para"][language.data]}</span>{" "}
                                    {template.to}
                                </p>
                                <p className="m-0 text-sm text-gray-600">
                                    <span className="font-semibold text-gray-900">{translations["sales-emails-assunto"][language.data]}</span>{" "}
                                    {template.subject}
                                </p>
                            </div>
                            <BoxTemplateContent>
                                <div>
                                    <div
                                        className="email-content max-h-[400px] overflow-auto rounded-md border border-gray-200 bg-white p-3"
                                        dangerouslySetInnerHTML={{ __html: template?.html }}
                                    />
                                </div>
                            </BoxTemplateContent>
                        </BoxTemplate>
                    </div>
                </div>
            </Container>
        </Modal>
    );
};

export default ModalEmails;
